import { render } from "./RestaurantsEdit.vue?vue&type=template&id=e6ca4584"
import script from "./RestaurantsEdit.vue?vue&type=script&lang=js"
export * from "./RestaurantsEdit.vue?vue&type=script&lang=js"

import "./RestaurantsEdit.vue?vue&type=style&index=0&id=e6ca4584&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__